// extracted by mini-css-extract-plugin
export var hide = "style-module--hide--cUA8H";
export var highlight = "style-module--highlight--9-9nx";
export var root = "style-module--root--t3Nul";